import { motion } from "framer-motion";

const steps = [
  {
    number: "01",
    title: "Discovery",
    description:
      "A complimentary consultation. We listen first—understanding your industry, financial picture, and specific goals before recommending anything.",
  },
  {
    number: "02",
    title: "Strategy",
    description:
      "A tailored roadmap. Whether it's tax optimization, bookkeeping systems, or fractional CFO guidance, you get a clear, prioritized plan with defined deliverables.",
  },
  {
    number: "03",
    title: "Execution",
    description:
      "Precise implementation. We handle the details with modern cloud tools while keeping you informed—no surprises, no unclear timelines.",
  },
  {
    number: "04",
    title: "Partnership",
    description:
      "Year-round advocacy. You get an ongoing thinking partner for every financial decision that follows, not just once-a-year contact.",
  },
];

const ProcessSection = () => {
  return (
    <section
      id="process"
      className="py-24 md:py-40 bg-[#1C1917] text-white relative overflow-hidden"
      data-testid="process-section"
    >
      <div className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px bg-[#C85A43] w-12" />
              <p className="text-sm md:text-base uppercase tracking-[0.3em] font-bold text-[#C85A43]">
                Our Process
              </p>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.02em] leading-[1.05] text-white">
              Simple.{" "}
              <span className="italic font-light text-[#C85A43]">
                Transparent.
              </span>{" "}
              Effective.
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-7 lg:pt-24"
          >
            <p className="text-lg text-[#A8A29E] leading-relaxed max-w-xl">
              A refined four-step approach that keeps things simple, avoids
              surprises, and delivers real financial clarity.
            </p>
          </motion.div>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#292524]">
          {steps.map((step, i) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="group bg-[#1C1917] p-8 md:p-10 hover:bg-[#0F0F0E] transition-colors duration-500 min-h-[280px] flex flex-col"
              data-testid={`process-step-${i + 1}`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-heading text-5xl font-light italic text-[#C85A43]">
                  {step.number}
                </span>
                <span className="w-8 h-px bg-[#78716C] mt-6 group-hover:w-12 group-hover:bg-[#C85A43] transition-all duration-500" />
              </div>
              <h3 className="font-heading text-2xl font-semibold text-white mb-4">
                {step.title}
              </h3>
              <p className="text-sm text-[#A8A29E] leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
